const ZEPTO_REMOVE_LABEL = 'Remove';
const ZEPTO_CLOSE_LABEL = 'Bağla';
const ZEPTO_PANEL_MARKERS = ['Oyma mətni', 'Mətnin yerləşməsini'];
const ZEPTO_ENGRAVING_MAX_LENGTH = 18;
const ZEPTO_DISALLOWED_CHARACTERS = /[^A-Za-z0-9ƏəĞğİıÖöŞşÜüÇç♥♡★☆∞•.,+\-& ]/g;

function isInsideZeptoPersonalizer(element) {
  let ancestor = element.parentElement;

  for (let depth = 0; ancestor && depth < 8; depth += 1, ancestor = ancestor.parentElement) {
    const text = ancestor.textContent || '';

    if (ZEPTO_PANEL_MARKERS.some((marker) => text.includes(marker))) {
      return true;
    }
  }

  return false;
}

function localizeZeptoToggle(root = document) {
  root.querySelectorAll('button, a, input[type="button"]').forEach((control) => {
    const label = control instanceof HTMLInputElement ? control.value : control.textContent;

    if (label?.trim() !== ZEPTO_REMOVE_LABEL || !isInsideZeptoPersonalizer(control)) return;

    if (control instanceof HTMLInputElement) {
      control.value = ZEPTO_CLOSE_LABEL;
    } else {
      control.textContent = ZEPTO_CLOSE_LABEL;
    }

    control.setAttribute('aria-label', ZEPTO_CLOSE_LABEL);
  });
}

function sanitizeZeptoEngravingInput(input, notifyZepto = false) {
  if (!(input instanceof HTMLInputElement) || input.type !== 'text' || !isInsideZeptoPersonalizer(input)) return;

  const sanitizedValue = input.value
    .replace(ZEPTO_DISALLOWED_CHARACTERS, '')
    .slice(0, ZEPTO_ENGRAVING_MAX_LENGTH);

  if (sanitizedValue === input.value) return;

  input.value = sanitizedValue;

  if (notifyZepto) {
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

function sanitizeAllZeptoEngravingInputs() {
  document.querySelectorAll('input[type="text"]').forEach((input) => {
    sanitizeZeptoEngravingInput(input, true);
  });
}

function initializeZeptoLocalization() {
  localizeZeptoToggle();

  document.addEventListener(
    'input',
    (event) => sanitizeZeptoEngravingInput(event.target),
    true
  );

  document.addEventListener('click', () => {
    window.setTimeout(sanitizeAllZeptoEngravingInputs, 100);
  });

  const observer = new MutationObserver(() => localizeZeptoToggle());
  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeZeptoLocalization, { once: true });
} else {
  initializeZeptoLocalization();
}
